<template>
  <div style="padding: 10px">
    <div style="margin: 10px 0">
      <el-input v-model="search.accountName" placeholder="账号名" @keyup.enter.native="load" style="width: 10%"
                clearable></el-input>
      <el-select v-model="search.parentRoleId" clearable filterable placeholder="请选择父账号" style="width: 10%">
        <el-option
            v-for="item in parentIdDict"
            :key="item.parentRoleId"
            :label="item.accountName"
            :value="item.parentRoleId">
        </el-option>
      </el-select>
      <el-button type="primary" style="margin-left: 5px" @click="load">查询</el-button>
      <el-button style="margin-left: 5px" @click="resetData">重置</el-button>
    </div>
    <el-table
        v-loading="loading"
        :data="tableData"
        border
        stripe
        style="width: 100%">
      <el-table-column
          prop="accountName"
          label="账号名">
      </el-table-column>
      <el-table-column prop="roleId" label="角色ID">
        <template #default="{row}">
        <span
            class="copyable-text"
            @click="copyToClipboard(row.roleId)"
        >
          {{ row.roleId }}
          <i class="el-icon-document-copy"></i>
        </span>
        </template>
      </el-table-column>
      <el-table-column
          prop="nextLoginTime"
          label="下次上号时间">
      </el-table-column>
      <el-table-column
          prop="nextCarClaimTime"
          label="下次赛车时间">
      </el-table-column>
      <el-table-column
          prop="nextTowerTime"
          label="下次爬塔时间">
      </el-table-column>

      <!-- 是否上号 - Switch开关 -->
      <el-table-column
          prop="loginStatus"
          label="是否上号">
        <template #default="{row}">
          <el-switch
              v-model="row.loginStatus"
              :active-value="1"
              :inactive-value="0"
              active-text="是"
              inactive-text="否"
              @change="handleStatusChange('loginStatus', row)">
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column
          prop="claimRewardStatus"
          label="是否收菜">
        <template #default="{row}">
          <el-switch
              v-model="row.claimRewardStatus"
              :active-value="true"
              :inactive-value="false"
              active-text="是"
              inactive-text="否"
              @change="handleStatusChange('claimRewardStatus', row)">
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column
          prop="dungeon"
          label="是否梦境">
        <template #default="{row}">
          <el-switch
              v-model="row.dungeon"
              :active-value="true"
              :inactive-value="false"
              active-text="是"
              inactive-text="否"
              @change="handleStatusChange('dungeon', row)">
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column
          prop="carClaim"
          label="是否赛车">
        <template #default="{row}">
          <el-switch
              v-model="row.carClaim"
              :active-value="true"
              :inactive-value="false"
              active-text="是"
              inactive-text="否"
              @change="handleStatusChange('carClaim', row)">
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column
          prop="towerStatus"
          label="是否爬塔">
        <template #default="{row}">
          <el-switch
              v-model="row.towerStatus"
              :active-value="true"
              :inactive-value="false"
              active-text="是"
              inactive-text="否"
              @change="handleStatusChange('towerStatus', row)">
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column
          prop="arenaStatus"
          label="是否竞技场">
        <template #default="{row}">
          <el-switch
              v-model="row.arenaStatus"
              :active-value="true"
              :inactive-value="false"
              active-text="是"
              inactive-text="否"
              @change="handleStatusChange('arenaStatus', row)">
          </el-switch>
        </template>
      </el-table-column>

      <!-- 是否日常 - Switch开关 -->
      <el-table-column
          prop="dailyTaskStatus"
          label="是否日常">
        <template #default="{row}">
          <el-switch
              v-model="row.dailyTaskStatus"
              :active-value="1"
              :inactive-value="0"
              active-text="是"
              inactive-text="否"
              @change="handleStatusChange('dailyTaskStatus', row)">
          </el-switch>
        </template>
      </el-table-column>

      <el-table-column label="操作" width="80px" v-if="this.userId === 1">
        <template #default="scope">
          <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div style="margin: 10px 0">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[5, 10, 20]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
      </el-pagination>
    </div>

    <!--新增编辑表单-->
    <el-dialog title="新增/编辑" v-model="dialogVisible" width="30%">
      <el-form :model="form">
        <el-form-item label="账号名">
          <el-input v-model="form.accountName"></el-input>
        </el-form-item>
        <el-form-item label="是否上号">
          <el-select v-model="form.loginStatus" placeholder="请选择是否上号" clearable>
            <el-option label="是" :value="1"></el-option>
            <el-option label="否" :value="0"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="是否日常">
          <el-select v-model="form.dailyTaskStatus" placeholder="请选择是否日常" clearable>
            <el-option label="是" :value="1"></el-option>
            <el-option label="否" :value="0"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
          <span class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="save">确 定</el-button>
          </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import request from "@/utils/request";

export default {
  name: 'accountInfo',
  components: {},
  data() {
    return {
      dialogVisible: false,
      parentIdDict: [],
      accountInfoDict: [],
      form: {
        createTime: '',
        loginStatus:'',
        dailyTaskStatus:'',
        claimRewardStatus:'',
        dungeon:'',
        carClaim:'',
        arenaStatus:'',
        towerStatus:''
      },
      clubForm: {
        type: '',
        ids: [],
        clubCode: ''
      },
      tenKingForm: {
        type: '',
        ids: []
      },
      userId: '',
      loading: true,
      search: {},
      query: {},
      currentPage: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      // 防抖定时器
      debounceTimer: null
    }
  },
  created() {
    this.load()
    let userStr = sessionStorage.getItem("user") || "{}"
    let user = JSON.parse(userStr)
    this.userId = user.id;
  },
  mounted() {
    this.getParentIdList();
    this.getAccountInfoList();
  },
  methods: {
    // Switch开关改变事件
    handleStatusChange(field, row) {
      // 防抖处理，避免频繁调用接口
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
      }

      this.debounceTimer = setTimeout(() => {
        this.updateStatus(field, row);
      }, 300);
    },

    // 更新状态到后端
    updateStatus(field, row) {
      this.loading = true;

      // 构建更新数据
      const updateData = {
        id: row.id, // 假设有id字段
        [field]: row[field]
      };

      request.post("/accountInfoWs/update", updateData).then(res => {
        this.loading = false;
        if (res.code === '0') {
          this.$message({
            type: "success",
            message: "更新成功"
          });
          // 可选：重新加载数据确保一致性
          // this.load();
        } else {
          // 更新失败，恢复原状态
          this.$message({
            type: "error",
            message: res.msg || "更新失败"
          });
          // 重新加载数据恢复正确状态
          this.load();
        }
      }).catch(error => {
        this.loading = false;
        this.$message({
          type: "error",
          message: "网络错误，更新失败"
        });
        // 重新加载数据恢复正确状态
        this.load();
      });
    },

    async copyToClipboard(text) {
      const textToCopy = text.toString()

      if (navigator.clipboard && window.isSecureContext) {
        try {
          await navigator.clipboard.writeText(textToCopy)
          this.$message.success('复制成功')
          return
        } catch (err) {
          console.warn('现代Clipboard API失败，使用降级方案')
        }
      }

      const textArea = document.createElement('textarea')
      textArea.value = textToCopy
      textArea.style.position = 'fixed'
      textArea.style.opacity = '0'

      document.body.appendChild(textArea)
      textArea.select()

      try {
        const successful = document.execCommand('copy')
        if (successful) {
          this.$message.success('复制成功')
        } else {
          this.$message.error('复制失败')
        }
      } catch (err) {
        this.$message.error('复制失败')
      } finally {
        document.body.removeChild(textArea)
      }
    },

    add() {
      this.dialogVisible = true
      this.form = {}
    },

    handleEdit(row) {
      this.form = JSON.parse(JSON.stringify(row))
      this.dialogVisible = true
    },

    save() {
      this.loading = true;
      if (this.form.id) {
        request.post("/accountInfoWs/update", this.form).then(res => {
          if (res.code === '0') {
            this.$message({
              type: "success",
              message: res.msg
            })
          } else {
            this.$message({
              type: "error",
              message: res.msg
            })
          }
          this.load()
          this.loading = false
          this.dialogVisible = false
        })
      }
    },

    resetData() {
      this.search = {}
      this.load()
    },

    getAccountInfoList() {
      request.get("/accountInfo/listNoPage", {}).then(res => {
        this.loading = false
        this.accountInfoDict = res.data
      })
    },

    getParentIdList() {
      request.get("/accountInfo/parentList", {}).then(res => {
        this.loading = false
        this.parentIdDict = res.data
      })
    },

    load() {
      this.loading = true
      const searchForm = {...this.search}
      let obj = Object.assign(searchForm, this.query)
      let reqData = {
        ...obj
      }
      reqData.current = this.currentPage
      reqData.size = this.pageSize
      request.get("/accountInfoWs/list", {
        params: reqData
      }).then(res => {
        this.loading = false
        this.tableData = res.data.records
        this.total = res.data.total
      })
    },

    handleSizeChange(pageSize) {
      this.pageSize = pageSize
      this.load()
    },

    handleCurrentChange(pageNum) {
      this.currentPage = pageNum
      this.load()
    },
  }
}
</script>

<style scoped>
/* 可选：为Switch添加一些样式 */
.el-switch {
  margin: 2px 0;
}
</style>
